var map = {
	"./level_0.svg": 78173,
	"./level_1.svg": 89947,
	"./level_2.svg": 65664,
	"./level_3.svg": 59854,
	"./level_4.svg": 45797,
	"./level_5.svg": 77897,
	"./level_6.svg": 60130,
	"./level_7.svg": 74242,
	"./level_8.svg": 92159
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 36106;
module.exports = webpackAsyncContext;